import EmailViewSummary from "@/domain/entities/dashboard/EmailViewSummary";
import CategoryTag, { categoryTagColors } from "@/domain/enums/CategoryTag";
import { useTranslation } from "react-i18next";

interface EmailProgressBarProps {
    viewInfos: EmailViewSummary;
}

const EmailProgressBar = ({ viewInfos }: EmailProgressBarProps) => {
    const { t } = useTranslation();

    return (
        <div className="mt-3 flex h-2 w-full gap-2">
            {viewInfos.categoryRepartition.map((repartition) => {
                const { percentage, categoryId } = repartition;
                if (!percentage || percentage === 0) {
                    return null;
                }

                const color = categoryTagColors[categoryId as CategoryTag];

                return (
                    <div
                        key={`${categoryId} mail bar`}
                        className="group relative h-full rounded-full"
                        style={{
                            width: `${percentage}%`,
                            backgroundColor: color,
                        }}
                    >
                        <div className="absolute left-1/2 top-3 -translate-x-1/2 scale-0 transform whitespace-nowrap rounded-md bg-neutral-darkest px-2 py-1 text-xs capitalize text-white opacity-0 transition-all duration-150 group-hover:scale-100 group-hover:opacity-100">
                            {t(`categories.${categoryId}`)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default EmailProgressBar;
